/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 import React, { Suspense } from 'react';
import Header from '../header/Header';
import Footer from "../footer/Footer";
import NavBar from '../navBar/NavBar';
import NoSubscription from '../noSubscription/NoSubscription';
import './layout.scss';
import EDW_CONST from '../../common/constants'
import ActiveArrow from "./activeIcons/ActiveArrow.png";
import ActiveLearn from "./activeIcons/ActiveLearn.png";


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <p className="loadingTxt">Loading failed! Please reload.</p>;
        }

        return this.props.children;
    }
}

const Layout = (props) => {
    const { children, isAuth, isUserSubscribed } = props;

    return (

        <div className="container-fluid content">
            <ErrorBoundary>
                <Suspense fallback={<div>Loading...</div>}>
                    <div className="row justify-content-center active-learn">
                        <div className="col-auto no-subscription-banner">
                            <div className="row no-gutters">
                                <a href={EDW_CONST.ALS_DOMAIN + EDW_CONST.ALS_MARK_BOOK} className="active-text">
                                        <img className="active-arrow-img" src={ActiveArrow} alt="" />
                                         Return to 
                                        <img className="active-learn-img" src={ActiveLearn} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-md-2 border1 left-navbar">
                            <NavBar {...props} />
                        </div>
                        <div className="col-md-10 dashboard_right p-0">
                            <Header {...props} />

                            <div style={{ padding: '0 10px' }}>
                                {
                                    isUserSubscribed ? (
                                        children
                                    ) : (
                                            <div> <NoSubscription /></div>

                                        )
                                }
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </ErrorBoundary>
        </div >



    );
};


export default Layout;



